module.exports = __webpack_public_path__ + "img/logo_icon.31d436e5.svg";